import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;



export const getNotificationAlert = async (notificationStatus,token) => {
  try {

    return await axios
      .get(`${API}/getNotificationAlert/${notificationStatus}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const getNotificationAssignedRoutes = async (token,contactTypeId,userId) => {
  try {
console.log('getNotificationAssignedRoutes',contactTypeId,userId)
    return await axios
      .get(`${API}/notification/getAssignedRoutes/${contactTypeId}/${userId}`, {
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};


export const setUserNotificationSubscription = async (userId,notificationRouteId,contactTypeId,isSubscribed,token) => {
  try {

    const data={userId,notificationRouteId,contactTypeId,isSubscribed}
    return await axios
      .post(`${API}/notification/setUserNotificationSubscription`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};